module.exports = __webpack_public_path__ + "img/bg_2_cht.026883f2.png";